import { Box, Typography } from "@mui/material";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import { useTheme } from "@mui/material/styles";

const NoProducts = ({title="No Products Available at the moment, Please try again later"}) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                textAlign: "center",
                py: 6,
                px: 3,
                borderRadius: 1,
                border: `1px dashed ${theme.palette.border.thin}`,
                backgroundColor: theme.palette.background.light5,
                my:2,
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <SentimentDissatisfiedIcon
                sx={{
                    fontSize: 64,
                    color: theme.palette.gray50,
                    mb: 2,
                }}
            />
            <Typography
                variant="h6"
                color={theme.palette.text.secondary}
                sx={{ mb: 1 }}
            >
                {title}
            </Typography>
        </Box>
    );
};

export default NoProducts;
